// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { IdlOptions, IdlOptionsT, verifyIdlOptions } from "./idl-options";
import { IdlSourceFile, IdlSourceFileT, verifyIdlSourceFile } from "./idl-source-file";

/**
 * Check an events XML on its own, with no IDL to send.
 *
 * The reading is the one `ValidateRequest` gives `IdlBundle.events_xml`,
 * under the same caps, and nothing else. The answer is an `IdlResult` whose
 * diagnostics all have source `EventsXml`; it holds no table, no commands
 * and no IDL finding. `events_xml.content` is a `Blob` of kind `EventsXml`,
 * as in a bundle.
 */
export class EventsCheckRequest implements flatbuffers.IUnpackableObject<EventsCheckRequestT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): EventsCheckRequest {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsEventsCheckRequest(
    bb: flatbuffers.ByteBuffer,
    obj?: EventsCheckRequest,
  ): EventsCheckRequest {
    return (obj || new EventsCheckRequest()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsEventsCheckRequest(
    bb: flatbuffers.ByteBuffer,
    obj?: EventsCheckRequest,
  ): EventsCheckRequest {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new EventsCheckRequest()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  eventsXml(obj?: IdlSourceFile): IdlSourceFile | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new IdlSourceFile()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  options(obj?: IdlOptions): IdlOptions | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new IdlOptions()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startEventsCheckRequest(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addEventsXml(builder: flatbuffers.Builder, eventsXmlOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, eventsXmlOffset, 0);
  }

  static addOptions(builder: flatbuffers.Builder, optionsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, optionsOffset, 0);
  }

  static endEventsCheckRequest(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // events_xml
    return offset;
  }

  unpack(): EventsCheckRequestT {
    return new EventsCheckRequestT(
      this.eventsXml() !== null ? this.eventsXml()!.unpack() : null,
      this.options() !== null ? this.options()!.unpack() : null,
    );
  }

  unpackTo(_o: EventsCheckRequestT): void {
    _o.eventsXml = this.eventsXml() !== null ? this.eventsXml()!.unpack() : null;
    _o.options = this.options() !== null ? this.options()!.unpack() : null;
  }

  unpackFields(...fields: string[]): EventsCheckRequestT {
    const t = new EventsCheckRequestT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("events_xml")) {
      t.eventsXml = this.eventsXml() !== null ? this.eventsXml()!.unpack() : null;
    }
    if (fieldSet.has("options")) {
      t.options = this.options() !== null ? this.options()!.unpack() : null;
    }
    return t;
  }
}

export class EventsCheckRequestT implements flatbuffers.IGeneratedObject {
  constructor(
    public eventsXml: IdlSourceFileT | null = null,
    public options: IdlOptionsT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.eventsXml === null || this.eventsXml === undefined) {
      throw new Error('Required field "events_xml" is not set');
    }
    const eventsXml = this.eventsXml !== null ? this.eventsXml!.pack(builder) : 0;
    const options = this.options !== null ? this.options!.pack(builder) : 0;

    EventsCheckRequest.startEventsCheckRequest(builder);
    EventsCheckRequest.addEventsXml(builder, eventsXml);
    EventsCheckRequest.addOptions(builder, options);

    return EventsCheckRequest.endEventsCheckRequest(builder);
  }

  clone(): EventsCheckRequestT {
    const obj = new EventsCheckRequestT();
    obj.eventsXml = this.eventsXml !== null ? this.eventsXml!.clone() : null;
    obj.options = this.options !== null ? this.options!.clone() : null;
    return obj;
  }

  equals(other: EventsCheckRequestT): boolean {
    if (this.eventsXml !== null && other.eventsXml !== null) {
      if (!this.eventsXml!.equals(other.eventsXml!)) return false;
    } else if (this.eventsXml !== other.eventsXml) return false;
    if (this.options !== null && other.options !== null) {
      if (!this.options!.equals(other.options!)) return false;
    } else if (this.options !== other.options) return false;
    return true;
  }
}

export function verifyEventsCheckRequest(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyIdlSourceFile(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "events_xml");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyIdlOptions(verifier, fieldPos + tableOffset);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
